import React from "react";
import styles from "./Sidebar.module.css";
import { Link, useLocation } from "react-router-dom";
import useMedia from "../../Hooks/useMedia";
import IconHome from "../../Assets/icons-home.svg";
import InstallButton from "../InstallButton/InstallButton";

const Sidebar = () => {
  const mobile = useMedia("(max-width: 850px)");
  const [mobileMenu, setMobileMenu] = React.useState(false);

  const { pathname } = useLocation();

  React.useEffect(() => {
    setMobileMenu(false);
  }, [pathname]);

  return (
    <>
      {mobile && (
        <button
          aria-label="Menu"
          className={`${styles.mobileButton} ${mobileMenu && styles.mobileButtonActive
            }`}
          onClick={() => setMobileMenu(!mobileMenu)}
        ></button>
      )}

      <nav
        className={`${mobile ? styles.navMobile : styles.containerNav} ${mobileMenu && styles.navMobileActive
          }`}
      >
        {/* HOME */}
        <Link className={`${styles.button} ${styles.buttonIconHome}`} to="/">
          <img src={IconHome} alt="Home" />
        </Link>

        {/* PRINCIPAL */}
        <Link className={styles.button} to="/ferramentas">
          Ferramentas
        </Link>

        <Link className={styles.button} to="/sobre">
          Sobre
        </Link>

        {/* NOVAS PÁGINAS IMPORTANTES */}
        <Link className={styles.button} to="/contato">
          Contato
        </Link>

        <Link className={styles.button} to="/politica-de-privacidade">
          Privacidade
        </Link>

        <Link className={styles.button} to="/termos-de-uso">
          Termos
        </Link>

        {/* INSTALAR APP */}
        <div className={styles.installItem}>
          <InstallButton compact />
        </div>
      </nav>
    </>
  );
};

export default Sidebar;